$(window).on('load', function () {
	if (window.matchMedia('(min-width: 769px)').matches) {
		$('.matchheight_box').matchHeight();
		$('.matchheight_box-01').matchHeight();
		$('.matchheight_box-02').matchHeight();
		$('.matchheight_box-03').matchHeight();
		$('.matchheight_box-04').matchHeight();
		$('.matchheight_box-05').matchHeight();
	}
});
